// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__23tiR","label":"Radio_label__2LnKk","checkMark":"Radio_checkMark__1SAFg","disabled":"Radio_disabled__kIvUg"};